import { Injectable, signal } from '@angular/core';
import { MenuItem } from '@shared/models/menu.model';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  showMenu = signal<boolean>(true);
  menuType: 'over' | 'side' = 'side';
  expandedMenuElementSig = signal<{ menu: MenuItem; parentMenu: MenuItem | null } | null>(null);

  constructor() {}

  updateMenuState(value: { menu: MenuItem; parentMenu: MenuItem | null } | null): void {
    this.expandedMenuElementSig.set(value);
  }

  toggleMenu() {
    this.showMenu.set(!this.showMenu());
  }
}
